import React, { useState, useContext, useCallback, useEffect } from "react";
import useReactRouter from "use-react-router";
import { Grid, Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import ManageUsage from "../../../Views/app/limit/ManageUsage";
import { ServiceContext } from "../../../Context/ServiceContext";
import { editServiceMore } from "../../../API/Service";
import { useSnackbar } from "notistack";
import { LangContext } from "../../../Context/Langcontext";

const useStyle = makeStyles((theme) => ({
  rowDetail: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    margin: "1rem 8rem",
    whiteSpace: "nowrap",
  },
  griditem: {},
  paper: {
    boxShadow: "unset",
    backgroundColor: "#f4f4f4",
    borderRadius: 8,
  },
  fontprimary: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#595a5a",
  },
  fontsecondary: {
    fontSize: "1rem",
    fontWeight: 200,
    color: "#595a5a",
  },
  gridbtn: {
    margin: "2rem 0rem",
  },
  activebtn: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#595a5a",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#595a5a",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  nonactive: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#9b9b9b",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#9b9b9b",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  btnstyle: {
    padding: "0.5rem 4rem",
    fontSize: "1rem",
    fontWeight: 200,
    textTransform: "unset",
    backgroundColor: "#E16733",
    color: "#FFFFFF",
    "&:hover": {
      backgroundColor: "#E16733",
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  gridend: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
}));

const Manageservice = () => {
  const { match, history } = useReactRouter();
  const classes = useStyle();
  const [checked, setChecked] = useState([]);
  const [fetch, setfetch] = useState(false);
  const serviceContext = useContext(ServiceContext);
  const [state, setstate] = useState({ data: [], map: [], premium: [] });
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setloading] = useState(false);
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const setData = useCallback(() => {
    const dataapi = serviceContext.data.filter((rs) => {
      return rs.category === "data";
    });
    const mapapi = serviceContext.data.filter((rs) => {
      return rs.category === "map";
    });

    const premiumapi = serviceContext.data.filter((rs) => {
      return rs.category === "premium";
    });

    const dataCheck = dataapi
      .sort((a, b) => {
        return a.type < b.type ? 1 : -1;
      })
      .map((rs) => {
        let respon = rs;

        // if (
        //   rs.user_roles.includes("public") ||
        //   rs.user_roles.includes("contract")
        // ) {
        //   respon.isCheck = true;
        // } else {
        //   respon.isCheck = false;
        // }
        return respon;
      });

    const mapCheck = mapapi
      .sort((a, b) => {
        return a.type < b.type ? 1 : -1;
      })
      .map((rs) => {
        let respon = rs;

        // if (
        //   rs.user_roles.includes("public") ||
        //   rs.user_roles.includes("contract")
        // ) {
        //   respon.isCheck = true;
        // } else {
        //   respon.isCheck = false;
        // }
        return respon;
      });

    const premiumCheck = premiumapi
      .sort((a, b) => {
        return a.type < b.type ? 1 : -1;
      })
      .map((rs) => {
        let respon = rs;
        return respon;
      });

    setstate({
      ...state,
      data: dataCheck,
      map: mapCheck,
      premium: premiumCheck,
    });
  }, [serviceContext, state]);

  useEffect(() => {
    if (!fetch && serviceContext.data.length !== 0) {
      setData();
      setfetch(true);
    } else {
    }
  }, [fetch, setData, serviceContext]);

  const onCheckedData = (index, e, role) => {
    let d;
    if (match.params.service === "data") {
      d = [...state.data];
    } else if (match.params.service === "premium") {
      d = [...state.premium];
    } else {
      d = [...state.map];
    }

    if (d[index].user_roles.includes(role)) {
      let filter = d[index].user_roles.filter((rs) => {
        return rs !== role;
      });
      d[index].user_roles = filter;
    } else {
      d[index].user_roles.push(role);
    }

    let filter = checked.filter((rs) => {
      return rs._id === d[index]._id;
    });

    if (filter.length !== 0) {
      let dataarr = [...checked];
      let id = checked
        .map((rs) => {
          return rs._id;
        })
        .indexOf(d[index]._id);
      dataarr[id] = d[index];
      setChecked(dataarr);
    } else {
      let dataarr = [...checked];
      dataarr.push(d[index]);
      setChecked(dataarr);
    }

    if (match.params.service === "data") {
      setstate({
        ...state,
        data: d,
      });
    } else if (match.params.service === "premium") {
      setstate({
        ...state,
        premium: d,
      });
    } else {
      setstate({
        ...state,
        map: d,
      });
    }
  };

  const onSave = async () => {
    let respon = [];
    setloading(true);
    checked.map(async (item) => {
      let edit = await editServiceMore(item._id, item);

      if (edit.status.code === 200) {
        respon.push(true);
      } else {
        respon.push(false);
        // enqueueSnackbar("Manage service error", {
        //   variant: "error",
        // });
      }
      return edit;
    });

    const resolve = await Promise.all(checked);
    if (resolve.length) {
      setloading(false);
      setfetch(false);
      setChecked([]);
      enqueueSnackbar(
        `${lang.Manageservicesuccess} ${resolve.length} ${lang.of} ${resolve.length}`,
        {
          variant: "success",
        }
      );
    }

    // setTimeout(() => {
    //   enqueueSnackbar(
    //     `${lang.Manageservicesuccess} ${
    //       respon.filter((rs) => {
    //         return rs === true;
    //       }).length
    //     } ${lang.of} ${respon.length}`,
    //     {
    //       variant: "success",
    //     }
    //   );
    //   setloading(false);
    //   setfetch(false);
    //   setChecked([]);
    // }, 2000);
  };

  return (
    <div style={{ margin: "2rem" }}>
      <Grid container className={classes.gridbtn}>
        <Grid item xs={12} sm={10} md={10} lg={6}>
          <Button
            variant="contained"
            className={
              match.params.service === "data"
                ? classes.activebtn
                : classes.nonactive
            }
            onClick={() => {
              history.push(`/app/limit/manage/data`);
            }}
          >
            Data API
          </Button>
          <Button
            variant="contained"
            className={
              match.params.service === "map"
                ? classes.activebtn
                : classes.nonactive
            }
            style={{ marginLeft: "1rem" }}
            onClick={() => {
              history.push(`/app/limit/manage/map`);
            }}
          >
            Map API
          </Button>
          <Button
            variant="contained"
            className={
              match.params.service === "premium"
                ? classes.activebtn
                : classes.nonactive
            }
            style={{ marginLeft: "1rem" }}
            onClick={() => {
              history.push(`/app/limit/manage/premium`);
            }}
          >
            Premium API
          </Button>
        </Grid>
        <Grid item xs={12} sm={2} md={2} lg={6} className={classes.gridend}>
          <Button
            variant="contained"
            className={classes.btnstyle}
            onClick={() => {
              onSave();
            }}
            disabled={!checked.length || loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {lang.Save}
          </Button>
        </Grid>
      </Grid>
      <Grid container>
        {match.params.service === "data" ? (
          <ManageUsage data={state.data} onChange={onCheckedData} />
        ) : match.params.service === "map" ? (
          <ManageUsage data={state.map} onChange={onCheckedData} />
        ) : match.params.service === "premium" ? (
          <ManageUsage data={state.premium} onChange={onCheckedData} />
        ) : null}
      </Grid>
    </div>
  );
};

export default Manageservice;
